import { useAppSelector } from '@shared/lib/redux'

import { painterStore } from './painter.slice'
import { mapStore } from '@components/map'

export const usePainter = () => {
  return useAppSelector(painterStore.selectors.selectPainter)
}

export const usePainterLayers = (usersCount: number) => {
  const { zoom } = useAppSelector(mapStore.selectors.selectMapCommon)
  return useAppSelector((store) =>
    painterStore.selectors.selectPainterLayers(store, usersCount, zoom)
  )
}

export const usePainterMode = () => {
  const isPaintMode = useAppSelector(
    painterStore.selectors.selectIsPaintStarted
  )
  return {
    isPaintModeActive: isPaintMode
  }
}
